import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import { getNameInitials } from '@/helpers/utils';
import { MyLink } from '@/components/MyLink';
import Avatar from '@/components/UI/Avatar';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { useGetCoFoundersList } from '@/query/queries/fundraising/useGetCoFoundersList';
import s from './index.module.scss';

export const FoundersConfirmation = ({ className }) => {
  const { data } = useGetCoFoundersList();
  const { t } = useTranslation('fundraising');
  const { user } = useGetMe();
  if (!data || data?.length === 1) return null;

  return (
    <div className={classnames(s.wrapper, className)}>
      <div className={s.header}>
        <h3 className="f-h3 f-500">{t('founder_confirmation.confirmation_from_founders')}</h3>
        <p className={classnames(s.desc, 'f-label')}>
          {t('founder_confirmation.before_round_starts')}
        </p>
      </div>
      {data.map(founder => (
        <div className={s.founder} key={founder.id}>
          <MyLink
            href={
              user.role_id === founder.id
                ? APP_LINKS.profile
                : `${APP_LINKS.founders}/${founder.id}`
            }
            className={s.link}
          >
            <Avatar
              size={50}
              alt={founder.avatar.name}
              src={founder.avatar.file}
              nameInitials={getNameInitials(founder.first_name, founder.last_name)}
              active={founder.is_confirmed}
              className={s.avatar}
            />
            <div className={s.founder_content}>
              <div className="f-body f-500 tl">{founder.full_name}</div>
              <div className="f-label f-400">{t('founder_confirmation.co_founder')}</div>
            </div>
          </MyLink>
          <div className={classnames(s.badge, founder.is_confirmed && 'active')}>
            {founder.is_confirmed
              ? t('founder_confirmation.confirmed')
              : t('founder_confirmation.not_ready_yet')}
          </div>
        </div>
      ))}
    </div>
  );
};
